import CustomCard from '../../components/CustomCard/CustomCard'
import BackButton from '../../components/CustomButton/BackButton'
import { Flex, Row, Typography, Spin, Col, Tabs } from 'antd'
import DealDetailNoSpace from "../../components/Details/DealDetailNoSpace"
import { useEffect, useMemo, useState, useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getTxnDetails, getDisputeById, getEscalationById } from '../../redux/slices/PaymentsSlice'
import { getUserList } from '../../redux/slices/UserSlice'
import { useParams, useNavigate } from 'react-router-dom'
import { capitalizeWords, formatCurrency } from '../../helpers/helpers'
import { formatPaymentDateTime } from './helpers'
import DealDetail from "../../components/Details/DealDetail"
import { GLOBAL_CONSTANTS, ROLE_MODAL_WIDTHS, DISPUTE_MODAL_CONFIG, MODAL_WIDTHS } from '../../constants/constants'
import CustomButton from '../../components/CustomButton/Button'
import CustomTable from '../../components/CustomTable/CustomTable'
import { getDisputeColumns } from "./Components/getPaymentColumns"
import CustomModal from '../../components/CustomModal/CustomModal'
import RaiseDisputeForm from './Components/RaiseDisputeForm'
import EscalateForm from './Components/EscalateForm'
import ResolveForm from './Components/ResolveForm'
import { PERM_CODE } from '../../constants/PermissionCodes'
import PaymentActivityLog from './Components/PaymentActivityLog'

const { Title, Text } = Typography

const TransactionSummaryContent = ({
    txnData,
    loading,
    columns,
    showDispute,
    openModal,
}) => (
    <Spin spinning={loading}>
        <Row align="middle">
            <Col xs={24} md={12}>
                <Flex align="center" justify='space-between' wrap>
                    <Title level={4}>Transaction Summary</Title>
                    <DealDetailNoSpace
                        label="Transaction Category"
                        value={<Text className='txn-cat'>{capitalizeWords(txnData?.transactionCategory)}</Text>}
                    />
                </Flex>
            </Col>
            <Col xs={24} md={12}>
                <Flex justify='flex-end'>
                    {showDispute && (
                        <CustomButton type="primary" onClick={() => openModal("raiseDispute", txnData)}>
                            Raise Dispute
                        </CustomButton>
                    )}
                </Flex>
            </Col>
        </Row>
        <div className='details-container'>
            <Row gutter={[16, 16]}>
                <Col xs={24} md={12}>
                    <div className='detail-col-container'>
                        <DealDetail
                            label="Transaction ID"
                            value={txnData?.transactionId || GLOBAL_CONSTANTS.NA}
                        />
                        <DealDetail
                            label="UTR"
                            value={txnData?.utr || GLOBAL_CONSTANTS.NA}
                        />
                        <DealDetail
                            label="Particulars"
                            value={txnData?.particulars || GLOBAL_CONSTANTS.NA}
                        />
                        <DealDetail
                            label="Beneficiary Name"
                            value={txnData?.beneficiaryName || GLOBAL_CONSTANTS.NA}
                        />
                        <DealDetail
                            label="Beneficiary Account Number"
                            value={txnData?.beneficiaryAccNum || GLOBAL_CONSTANTS.NA}
                        />
                        <DealDetail
                            label="Remitter Name"
                            value={txnData?.remitterName || GLOBAL_CONSTANTS.NA}
                        />
                        <DealDetail
                            label="Remitter Account Number"
                            value={txnData?.remitterAccNum || GLOBAL_CONSTANTS.NA}
                        />
                    </div>
                </Col>
                <Col xs={24} md={12}>
                    <div className='detail-col-container'>
                        <DealDetail
                            label="Comments"
                            value={txnData?.comments || GLOBAL_CONSTANTS.NA}
                        />
                        <DealDetail
                            label="Transaction Status"
                            value={<Text className='txn-status'>{capitalizeWords(txnData?.transactionStatus)}</Text> || GLOBAL_CONSTANTS.NA}
                        />
                        <DealDetail
                            label="Transaction Date"
                            value={formatPaymentDateTime(txnData?.transactionDate) || GLOBAL_CONSTANTS.NA}
                        />
                        <DealDetail
                            label="Transaction Amount"
                            value={formatCurrency(txnData?.transactionAmount) || GLOBAL_CONSTANTS.NA}
                        />
                        <DealDetail
                            label="Requested By"
                            value={`${txnData?.requestedBy?.userId}(${txnData?.requestedBy?.email})` || GLOBAL_CONSTANTS.NA}
                        />
                        <DealDetail
                            label="User Role"
                            value={txnData?.requestedBy?.userRole || GLOBAL_CONSTANTS.NA}
                        />
                    </div>
                </Col>
            </Row>
        </div>
        {/* <Title level={4} style={{ marginTop: 30 }}>Dispute Summary</Title>
        <CustomTable
            rowKey="disputeId"
            columns={columns}
            dataSource={txnData?.disputeDetails || []}
            tableContainerStyle='dispute-table'
        /> */}
    </Spin>
)

const PaymentDetails = () => {
    const dispatch = useDispatch()
    const { txnId, tabIndex } = useParams();
    const navigate = useNavigate()
    const { user } = useSelector((state) => state.auth);
    const { txnData, loading } = useSelector((state) => state.payments);
    const [modal, setModal] = useState({
        type: null,
        data: null
    });

    const notAllowToRaiseDis = txnData?.particulars === "deposit"
        || txnData?.particulars === "Suspicious"
        || txnData?.particulars === "enterprise recived amount"
        || txnData?.particulars?.startsWith("Purchasing")
        || txnData?.particulars === "withdraw"

    const userPrivileges = user?.privilege?.map((p) => p.privilegeCode) || [];

    const showDispute = (userPrivileges.includes(PERM_CODE.PTDIS) && tabIndex === "1" && !notAllowToRaiseDis) ||
        (userPrivileges.includes(PERM_CODE.PRDIS) && tabIndex === "3" && !notAllowToRaiseDis)

    const showEscalate = (userPrivileges.includes(PERM_CODE.PTESC) && tabIndex === "1") ||
        (userPrivileges.includes(PERM_CODE.PDESC) && tabIndex === "2") ||
        (userPrivileges.includes(PERM_CODE.PRESC) && tabIndex === "3")


    const showResolve = (userPrivileges.includes(PERM_CODE.PTRES) && tabIndex === "1") ||
        (userPrivileges.includes(PERM_CODE.PDRES) && tabIndex === "2") ||
        (userPrivileges.includes(PERM_CODE.PRRES) && tabIndex === "3")

    useEffect(() => {
        dispatch(getTxnDetails(txnId));
    }, [txnId, dispatch]);

    const openModal = useCallback(async (type, dispute) => {
        setModal({ type, data: dispute });
        if (type === "escalate") {
            let data = await dispatch(getDisputeById(dispute));
            data = { ...data.payload }
            dispatch(getUserList());
            if (data?.DisputeEscalationDetail?.escalationId) {
                await dispatch(getEscalationById(data?.DisputeEscalationDetail?.escalationId));
            }
        }
    }, [dispatch]);

    const closeModal = useCallback(() => setModal({ type: null, data: null }), []);

    const columns = useMemo(
        () =>
            getDisputeColumns({
                showEscalate: showEscalate,
                showResolve: showResolve,
                onEscalate: (id) => openModal("escalate", id),
                onResolve: (dispute) => openModal("resolve", dispute),
                onView: (id) => navigate(`/payments/payment-details/${txnId}/dispute-details/${id}`)
            }),
        [navigate, openModal, showEscalate, showResolve, txnId]
    );

    return (
        <div className='payment-details-container'>
            <BackButton />
            <CustomCard className='payment-details-card'>
                <Tabs
                    className="payments-tabs"
                    items={[
                        {
                            key: 'summary',
                            label: 'Transaction Summary',
                            children: (
                                <TransactionSummaryContent
                                    txnData={txnData}
                                    loading={loading}
                                    columns={columns}
                                    showDispute={showDispute}
                                    openModal={openModal}
                                />
                            ),
                        },
                        {
                            key: 'activity',
                            label: 'Activity Log',
                            children: (
                                <PaymentActivityLog transactionId={txnId} />
                            ),
                        },
                    ]}
                />
                {modal.type && (
                    <CustomModal
                        title={DISPUTE_MODAL_CONFIG[modal.type]?.title}
                        open
                        centered
                        width={modal.type === "resolve" ? MODAL_WIDTHS : ROLE_MODAL_WIDTHS}
                        content={
                            <>
                                {modal.type === "escalate" ? (
                                    <EscalateForm
                                        onClose={closeModal}
                                    />
                                ) : modal.type === "resolve" ? (
                                    <ResolveForm
                                        onClose={closeModal}
                                        txnData={txnData}
                                        disputeData={modal.data}
                                    />
                                ) : (
                                    <RaiseDisputeForm
                                        onClose={closeModal}
                                        data={modal.data}
                                    />
                                )}

                            </>
                        }
                    />
                )}
            </CustomCard>
        </div>
    )
}

export default PaymentDetails